import { useSeo } from '@/lib/seo';

export default function PrivacyPage() {
  useSeo({ title: 'Privacy | A Guy Who Hunts', description: 'Privacy policy for aguywhohunts.com.' });
  return (
    <div className="mx-auto max-w-[72ch] px-4 sm:px-6 lg:px-8 py-16 prose-editorial">
      <p className="kicker">Privacy</p>
      <h1 className="font-serif text-4xl tracking-tight mt-2">Privacy Policy</h1>
      <p>
        This site collects only the information you provide directly — email address (and optional first name) for The
        Field Report newsletter, and any information you send through the contact form.
      </p>
      <h2>What we do not do</h2>
      <ul>
        <li>We do not sell your information.</li>
        <li>We do not share your email with third parties for marketing.</li>
        <li>We do not publish precise property, public-land, or trail-camera locations.</li>
      </ul>
      <h2>Cookies &amp; analytics</h2>
      <p>
        This site may use privacy-conscious analytics to understand which posts resonate. Analytics is aggregate and
        does not identify individual visitors.
      </p>
      <h2>Your rights</h2>
      <p>You may unsubscribe from The Field Report at any time or ask for your data to be removed by emailing us.</p>
    </div>
  );
}
